import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class CalWatsAttribute extends Sensor {
  public calWatsChart: any;
  private calWatsSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.calWatsChart = null;
    this.calWatsSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.calWatsSensor, position);
      this.calWatsSensor[position].push([timestamp, element.calWats]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredCalWats = this.calWatsSensor.filter(series => series.length > 0);

    const positionNodeCalWats = this.calWatsSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.calWatsChart = this.getConfigChar(
      'calWats',
      this.getChartSeriesNewNode('Sensor', filteredCalWats, positionNodeCalWats),
      this.getRanges('calWats'),
      this.getLimits('calWats')
    );
  }

  public hasCalWatsSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.calWatsSensor.length &&
      this.calWatsSensor[index].length > 0
    );
  }

  public getCalWatsSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.calWatsSensor.length) {
      const sensorData = this.calWatsSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Calorías (Wats)', value: 'calWats' }
    ];
  }
}
